import { FilterCoordinates } from 'components/UnitsFilters/types';

export const roundCoordinates = (
  coordinates: FilterCoordinates,
  decimals = 6
) => {
  return {
    southWest: {
      lat: +coordinates?.southWest?.lat?.toFixed(decimals),
      lng: +coordinates?.southWest?.lng?.toFixed(decimals),
    },
    northEast: {
      lat: +coordinates?.northEast?.lat?.toFixed(decimals),
      lng: +coordinates?.northEast?.lng?.toFixed(decimals),
    },
  };
};

export const formatCoordinates = (
  sw: string[],
  ne: string[]
): FilterCoordinates => {
  return {
    southWest: {
      lat: +sw[0],
      lng: +sw[1],
    },
    northEast: {
      lat: +ne[0],
      lng: +ne[1],
    },
  };
};
